import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail1Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail1Sparkle"><Path d="M22 15.0713L21.9473 15.0518L20.7734 12H17.2266L16.0518 15.0518L13 16.2266V20H2V5.96289L12 13.2363L22 5.96289V15.0713Z" fill="currentColor"/><Path d="M12 10.7637L2.7002 4H21.2998L12 10.7637Z" fill="currentColor"/><Path d="M19.4 14H18.6L17.6 16.6L15 17.6V18.4L17.6 19.4L18.6 22H19.4L20.4 19.4L23 18.4V17.6L20.4 16.6L19.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail1Sparkle;
